const appConfig = {
  "name": "spaces-admin",
  "version": "1.0.0",
  "stage": "develop",
  "regions": [
    {
      "name": "us-east-1",
      "isPrimaryRegion": true,
      "deployThisBuild": true,
      "regionDomain": "get.atlas-config-dev.mit.edu",
      "amplify": {
        "userPoolId": "us-east-1_14cFcpuS8",
        "userPoolWebClientId": "6k28gielhf43asur2b3k8na6m4",
        "oauth": {
          "domain": "atlas-auth-dev.mit.edu",
          "scope": [
            "profile",
            "openid",
            "digital-id/user",
            "digital-id/search",
            "spaces/admin",
            "user/all",
            "feature/user"
          ],
          "redirectSignIn": "https://spaces-admin-dev.mit.edu",
          "redirectSignOut": "https://spaces-admin-dev.mit.edu/logout",
          "responseType": "token",
          "options": {
            "AdvancedSecurityDataCollectionFlag": false
          }
        }
      },
      "signInProvider": "Touchstone",
      "api": {
        "domain": "api-dev.mit.edu",
        "paths": {
          "digital-id": "digital-id-v1",
          "spaces": "spaces-v1",
          "spacesV2": "spaces-v2",
          "scheduling": "scheduling-v1",
          "features": "feature-v1"
        }
      }
    },
    {
      "name": "us-west-1",
      "isPrimaryRegion": false,
      "deployThisBuild": true,
      "regionDomain": "get.atlas-config-dev.mit.edu",
      "amplify": {
        "userPoolId": "us-west-1_zBZDEjiKC",
        "userPoolWebClientId": "16r3r10hjb0est5eat4npe188l",
        "oauth": {
          "domain": "atlas-auth-us-west-dev.mit.edu",
          "scope": [
            "profile",
            "openid",
            "digital-id/user",
            "digital-id/search",
            "spaces/admin",
            "user/all",
            "feature/user"
          ],
          "redirectSignIn": "https://spaces-admin-dev.mit.edu",
          "redirectSignOut": "https://spaces-admin-dev.mit.edu/logout",
          "responseType": "token",
          "options": {
            "AdvancedSecurityDataCollectionFlag": false
          }
        }
      },
      "signInProvider": "Touchstone",
      "api": {
        "domain": "api-us-west-dev.mit.edu",
        "paths": {
          "digital-id": "digital-id-v1",
          "spaces": "spaces-v1",
          "spacesV2": "spaces-v2",
          "scheduling": "scheduling-v1",
          "features": "feature-v1"
        }
      }
    }
  ]
};
export default appConfig;